import { render } from 'react-dom';
import React, { StrictMode, useState } from 'react';
import { ThemeProvider } from '@material-ui/core';
import globalMaterialUITheme from '@alo/yoga-ui';
import { CareerHero } from './CareerHero';
import { CareerCollage } from './CareerCollage';
import { CareerFullWidthMedia } from './CareerFullWidthMedia';
import { CareerListings } from './CareerListings';
import { hqTab } from './constants';

const CareerPage = ({ data }: { data: DOMStringMap }) => {
  const [activeTab, setActiveTab] = useState<string>(hqTab);
  const isHq = activeTab === hqTab;
  const { heroTitle, heroSubtitle, heroCopy, heroCtaText, heroImageHq, heroImageRetail, fwmOneImageHq } = data;
  const { fwmOneImageRetail, fwmOneTitle, fwmOneCopy, collageImageHq1, collageImageHq2, collageImageRetail1 } = data;
  const { collageImageRetail2, collageTitle, collageCopy, fwmTwoImageHq, fwmTwoImageRetail } = data;
  const collageImageUrl1 = isHq ? collageImageHq1 : collageImageRetail1;
  const collageImageUrl2 = isHq ? collageImageHq2 : collageImageRetail2;
  const heroImageUrl = isHq ? heroImageHq : heroImageRetail;
  const fwmImageUrl = isHq ? fwmOneImageHq : fwmOneImageRetail;
  const fwmImageUrl2 = isHq ? fwmTwoImageHq : fwmTwoImageRetail;
  return (
    <ThemeProvider theme={globalMaterialUITheme}>
      {heroImageUrl && (
        <CareerHero
          title={heroTitle}
          subtitle={heroSubtitle}
          copy={heroCopy}
          imageUrl={heroImageUrl}
          ctaText={heroCtaText}
        />
      )}
      <CareerListings activeTab={activeTab} setActiveTab={setActiveTab} />
      {fwmImageUrl && <CareerFullWidthMedia imageUrl={fwmImageUrl} title={fwmOneTitle} copy={fwmOneCopy} />}
      {collageCopy && (
        <CareerCollage
          imageUrl1={collageImageUrl1}
          imageUrl2={collageImageUrl2}
          title={collageTitle}
          copy={collageCopy}
        />
      )}
      {fwmImageUrl2 && <CareerFullWidthMedia imageUrl={fwmImageUrl2} />}
    </ThemeProvider>
  );
};

const node = document.querySelector('[react-render-target="Careers"]');
render(<StrictMode>{node && <CareerPage data={node.dataset} />}</StrictMode>, node);

export default CareerPage;
